/**
 * @file veui-toast
 * @description PC、H5的提示
 */

import toast from 'veui/managers/toast';

export default {
    success(msg) {
        return toast.success(msg);
    },
    warn(msg) {
        return toast.warn(msg);
    },
    error(msg) {
        return toast.error(msg);
    },
    info(msg) {
        return toast.info(msg);
    }
};
